// Copyright (c) 2025 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import type { JSX } from "react";
import { connect } from "react-redux";
import { Overlay, Popover } from "react-bootstrap";
import { IAction } from "actions";
import { IState } from "states/states";

import IconHelp from "icons/iconHelp";
import IconInfo from "icons/iconInfo";

interface IHelpIconExtProps {
  text: string | JSX.Element;
  className?: string;
  style?: React.CSSProperties;
  useInfoIcon?: boolean;
}

interface IHelpIconProps {}

const mapStateToProps = (state: IState, ownProps: IHelpIconExtProps) => {
  const props: IHelpIconProps = {};
  return props;
};

interface IHelpIconState {
  isOpen: boolean;
}

interface IHelpIconDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IHelpIconDispatch = {};
  return dispatchProps;
};

export class HelpIconComponent extends React.Component<
  IHelpIconExtProps & IHelpIconProps & IHelpIconDispatch,
  IHelpIconState
> {
  public state: IHelpIconState = {
    isOpen: false,
  };
  private triggerRef = React.createRef<HTMLSpanElement>();

  public render() {
    const classes = ["img-link"];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return (
      <span className={classes.join(" ")}>
        <span
          tabIndex={0}
          className="help-icon-trigger"
          ref={this.triggerRef}
          onClick={() => this.setState({ isOpen: !this.state.isOpen })}
          onKeyDown={(e) => {
            if (e.key === "Escape") this.setState({ isOpen: false });
            else if (["Enter", " "].includes(e.key)) this.setState({ isOpen: !this.state.isOpen });
          }}
        >
          {this.props.useInfoIcon ?
            <IconInfo style={this.props.style} />
          : <IconHelp style={this.props.style} />}
        </span>
        <Overlay
          show={this.state.isOpen}
          target={this.triggerRef.current}
          placement="right"
          rootClose
          onHide={() => this.setState({ isOpen: false })}
        >
          <Popover id="help-popover">
            <Popover.Body>{this.props.text}</Popover.Body>
          </Popover>
        </Overlay>
      </span>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpIconComponent);
